<template>
    <LayoutPage
        imageName="map-bg.jpg"
        :title="title">
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="data.title"
                :description="data.description"
            />
        </template>
        <template v-slot:content>
            <section class="mm-section" style="overflow: hidden;">
                <div class="mm-subsection">
                    <div class="content-wrapper">
                        <div class="image">
                            <img
                                v-if="$te('professionalPage.imageA.responsiveImage')"
                                :src="$t('professionalPage.imageA.responsiveImage.src')"
                                :srcset="$t('professionalPage.imageA.responsiveImage.srcset')"
                            />
                        </div>

                        <div class="content">
                            <div class="container-fluid">
                                <IconFeatureList
                                    itemClassName="col-lg-6 col-md-4 col-sm-6"
                                    :list="data.featureIconListsA"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="mm-subsection" style="">
                    <div class="content-wrapper content-wrapper-50">
                        <div class="image">
                            <img
                                v-if="$te('professionalPage.imageB.responsiveImage')"
                                :src="$t('professionalPage.imageB.responsiveImage.src')"
                                :srcset="$t('professionalPage.imageB.responsiveImage.srcset')"
                            />
                        </div>
                        <div class="content">
                            <div class="container-fluid">
                                <IconFeatureList
                                    itemClassName="col-lg-6 col-md-4 col-sm-6"
                                    :list="data.featureIconListsB"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <div class="box box--center box--space-bottom">
                <router-link
                    :to="localeRoute('pricing')"
                    class="button button button--wider-border button--small-text transparent--button button--l button--uppercase button--float-left">
                    {{$t('professionalPage.buttonPricing')}}
                </router-link>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

import IconFeatureList from '@/components/solutions/iconFeatureList';
export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        IconFeatureList
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    },
    data() {
        return {
            title: "Professional",
            data: this.$t('professionalPage')
        };
    }

}
</script>


<style lang="scss" scoped>
    .vue-page {
        .content-wrapper {
            -ms-flex-wrap: wrap;
                flex-wrap: wrap;
            width: 130rem;
            max-width: 100%;
            padding: 0;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            position: relative;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            padding-bottom: 3rem;

            .image {
                max-width: 100%;
                padding: 0rem 0 2rem 0;
            }

            .content {
                width: 100%;
                padding: 0;
            }

            @media (min-width: 576px) {
                .content {
                    padding: 0 2rem;
                }
            }
        }


        @media (min-width: 992px) {

            .content-wrapper {
                -webkit-box-pack: start !important;
                -ms-flex-pack: start !important;
                justify-content: flex-start !important;
                -ms-flex-wrap: initial;
                flex-wrap: initial;

                .image {
                    margin-left: 50rem;
                    position: absolute;
                    max-height: 600px;
                }

                .content {
                    z-index: 1000;
                    width: 50rem;
                    padding: 4rem 2rem;
                }
            }

            .content-wrapper-50 {
                flex-direction: row-reverse;
                -webkit-box-pack: end !important;
                -ms-flex-pack: end !important;
                justify-content: flex-end !important;

                 .image {
                        margin: 0;
                        left: 0;
                        width: 50%;

                    img {
                        position: absolute;
                        right: 0;
                    }
                }

                .content {
                    right: 0;
                    width: 50%;
                    max-width: 50rem;
                    left: 50%;
                    position: relative;
                    padding-bottom: 4rem;
                }
            }

        }
    }
</style>
